/**
 * @generated SignedSource<<23ea1f0784228a5e3371bb74b74ca07f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobEventAgentLost_event$data = {
  readonly timestamp: any;
  readonly " $fragmentType": "JobEventAgentLost_event";
};
export type JobEventAgentLost_event$key = {
  readonly " $data"?: JobEventAgentLost_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobEventAgentLost_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventAgentLost_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node as any).hash = "c960465a887fe4a3fe9b65a7fb5cc94a";

export default node;
